// third-party
import { FormattedMessage } from 'react-intl';
import HouseSidingIcon from '@mui/icons-material/HouseSiding';
// assets
import { KyberNetwork,User, Building,  SecurityUser, People,Briefcase,TaskSquare,Graph, ReceiptEdit, MoneyChange, MoneyArchive ,WalletMoney, Calendar1} from 'iconsax-react';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  applications: KyberNetwork,
  dashboard: People,
  people: People,
  department:Briefcase,
  manager:SecurityUser,
  employee:User,
  project:Building,
  attendance:TaskSquare,
  report:Graph,
  quotation:MoneyArchive,
  invoice:ReceiptEdit,
  payment:MoneyChange,
  purchases:WalletMoney,
  calendar: Calendar1,

};

// ==============================|| MENU ITEMS - APPLICATIONS ||============================== //

const project: NavItemType = {
    id: 'project',
    title: <FormattedMessage id="projects" />,
    type: 'collapse',
    icon: HouseSidingIcon,
    breadcrumbs: true,
    permissions:['NL_PROJECT_R'],

    children:[
        {
          id: 'project-list',
          title: <FormattedMessage id="projects" />,
          type: 'item',
          url: '/project/job',
          icon: icons.project,
          breadcrumbs: true
        },
        {
          id: 'job-calendar',
          title: <FormattedMessage id="job-calendar" />,
          type: 'item',
          url: '/project/job/calendar',
          icon: icons.calendar,
          breadcrumbs: true
        }
      ]
    // },
   
    // {
    //   id: 'project-quotation',
    //   title: <FormattedMessage id="quotation" />,
    //   type: 'item',
    //   url: '/project/quotation',
    //   icon: icons.quotation,
    //   breadcrumbs: true,
    //   permissions:['NL_PROJECT_QUOTATION_R','NL_PROJECT_QUOTATION_C','NL_PROJECT_QUOTATION_U','NL_PROJECT_QUOTATION_D','NL_PROJECT_QUOTATION_L','NL_PROJECT_QUOTATION_U_ST'],
    //   children: [
    //     {
    //       id: 'project-quotation-list',
    //       title: <FormattedMessage id="project-quotation-list" />,
    //       type: 'item',
    //       url: '/project/quotation',
    //       icon: icons.applications,
    //       breadcrumbs: true
    //     },
    //     {
    //       id: 'project-quotation-new',
    //       title: <FormattedMessage id="project-quotation-new" />,
    //       type: 'item',
    //       url: '/project/quotation/new-quotation/',
    //       icon: icons.applications,
    //       breadcrumbs: true
    //     },
    //     {
    //       id: 'project-quotation-new',
    //       title: <FormattedMessage id="project-quotation-edit" />,
    //       type: 'item',
    //       url: '/project/quotation/edit-quotation/1',
    //       icon: icons.applications,
    //       breadcrumbs: true
    //     },
    //   ]
    // },
    // {
    //   id: 'project-invoice',
    //   title: <FormattedMessage id="invoices" />,
    //   type: 'item',
    //   url: '/project/invoice',
    //   icon: icons.invoice,
    //   breadcrumbs: true,
    //   permissions:['NL_PROJECT_INVOICES_R','NL_PROJECT_INVOICES_C','NL_PROJECT_INVOICES_U','NL_PROJECT_INVOICES_D','NL_PROJECT_INVOICES_L','NL_PROJECT_INVOICES_U_ST'],
    //   children: [
    //     {
    //       id: 'project-invoice-list',
    //       title: <FormattedMessage id="project-invoice-list" />,
    //       type: 'item',
    //       url: '/project/invoice',
    //       icon: icons.applications,
    //       breadcrumbs: true
    //     },
    //     {
    //       id: 'project-invoice-new',
    //       title: <FormattedMessage id="project-invoice-new" />,
    //       type: 'item',
    //       url: '/project/invoice/new-invoice/',
    //       icon: icons.applications,
    //       breadcrumbs: true
    //     },
    //     {
    //       id: 'project-invoice-new',
    //       title: <FormattedMessage id="project-invoice-edit" />,
    //       type: 'item',
    //       url: '/project/invoice/edit-invoice/1',
    //       icon: icons.applications,
    //       breadcrumbs: true
    //     },
    //   ]
    // },
    // {
    //   id: 'project-purchase',
    //   title: <FormattedMessage id="purchases" />,
    //   type: 'item',
    //   url: '/project/purchase',
    //   icon: icons.purchases,
    //   breadcrumbs: true,
    //   permissions:['NL_PROJECT_PURCHASES_R','NL_PROJECT_PURCHASES_C','NL_PROJECT_PURCHASES_U','NL_PROJECT_PURCHASES_D','NL_PROJECT_PURCHASES_L','NL_PROJECT_PURCHASES_U_ST'],
    //   children: [
    //     {
    //       id: 'project-purchase-list',
    //       title: <FormattedMessage id="project-purchase-list" />,
    //       type: 'item',
    //       url: '/project/purchase',
    //       icon: icons.purchases,
    //       breadcrumbs: true
    //     },
    //     {
    //       id: 'project-purchase-new',
    //       title: <FormattedMessage id="project-purchase-new" />,
    //       type: 'item',
    //       url: '/project/purchase/new-purchase/',
    //       icon: icons.applications,
    //       breadcrumbs: true
    //     },
    //     {
    //       id: 'project-purchase-new',
    //       title: <FormattedMessage id="project-purchase-edit" />,
    //       type: 'item',
    //       url: '/project/purchase/edit-purchase/1',
    //       icon: icons.applications,
    //       breadcrumbs: true
    //     },
    //   ]
    // },
    // {
    //   id: 'project-payment',
    //   title: <FormattedMessage id="payments" />,
    //   type: 'item',
    //   url: '/project/payments',
    //   icon: icons.payment
    //   ,
    //   breadcrumbs: true,
    //   permissions:['NL_PROJECT_PAYMENTS_R','NL_PROJECT_PAYMENTS_C','NL_PROJECT_PAYMENTS_U','NL_PROJECT_PAYMENTS_D','NL_PROJECT_PAYMENTS_L','NL_PROJECT_PAYMENTS_U_ST'],
    //   children: [
    //     {
    //       id: 'project-payment-list',
    //       title: <FormattedMessage id="project-payment-list" />,
    //       type: 'item',
    //       url: '/project/payments',
    //       icon: icons.applications,
    //       breadcrumbs: true
    //     },
    //     {
    //       id: 'project-payment-new',
    //       title: <FormattedMessage id="project-payment-new" />,
    //       type: 'item',
    //       url: '/project/payment/new-payment/',
    //       icon: icons.applications,
    //       breadcrumbs: true
    //     },
    //     {
    //       id: 'project-payment-new',
    //       title: <FormattedMessage id="project-payment-edit" />,
    //       type: 'item',
    //       url: '/project/payment/edit-payment/1',
    //       icon: icons.applications,
    //       breadcrumbs: true
    //     },
    //   ]
    // },
    // {
    //   id: 'project-order-material',
    //   title: <FormattedMessage id="order-material" />,
    //   type: 'item',
    //   url: '/project/order-material',
    //   icon: icons.applications,
    //   breadcrumbs: true,
    //   children: [
    //     {
    //       id: 'project-order-material-list',
    //       title: <FormattedMessage id="project-order-material-list" />,
    //       type: 'item',
    //       url: '/project/order-material',
    //       icon: icons.applications,
    //       breadcrumbs: true
    //     },
    //
    //     {
    //       id: 'project-order-material-view-material',
    //       title: <FormattedMessage id="project-order-material-view" />,
    //       type: 'item',
    //       url: '/project/order-material/view/1',
    //       icon: icons.applications,
    //       breadcrumbs: true
    //     },
    //   ]
    // },
  // ]
};

export default project;
